import { gql } from "@grandvisionhq/graphql";
const addProductBackInStockSubscriptionSuccessFragment = gql`
  fragment AddProductBackInStockSubscriptionSuccessFragment on AddProductBackInStockSubscriptionSuccessResponse {
    result {
      success
    }
  }
`;
const addProductBackInStockSubscriptionFailureFragment = gql`
  fragment AddProductBackInStockSubscriptionFailureFragment on AddProductBackInStockSubscriptionFailureResponse {
    failures {
      ... on BackInStockAlreadySubscribedFailure {
        message
      }
    }
  }
`;
const ADD_PRODUCT_BACK_IN_STOCK_SUBSCRIPTION = gql`
  mutation AddProductBackInStockSubscription($input: AddProductBackInStockSubscriptionInput!) {
    addProductBackInStockSubscription(input: $input) {
      ...AddProductBackInStockSubscriptionSuccessFragment
      ...AddProductBackInStockSubscriptionFailureFragment
    }
  }
  ${addProductBackInStockSubscriptionSuccessFragment}
  ${addProductBackInStockSubscriptionFailureFragment}
`;
export {
  ADD_PRODUCT_BACK_IN_STOCK_SUBSCRIPTION
};
//# sourceMappingURL=add-product-back-in-stock-subscription.js.map
